import { render, staticRenderFns } from "./gszzInner.vue?vue&type=template&id=a96e1a34&scoped=true"
import script from "./gszzInner.vue?vue&type=script&lang=js"
export * from "./gszzInner.vue?vue&type=script&lang=js"
import style0 from "./gszzInner.vue?vue&type=style&index=0&id=a96e1a34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96e1a34",
  null
  
)

export default component.exports